import { z } from "zod";

enum MetadataType {
  /** BOOLEAN */
  Boolean = "BOOLEAN",
  /** DATETIME */
  Datetime = "DATETIME",
  /** DOUBLE */
  Double = "DOUBLE",
  /** INT */
  Int = "INT",
  /** JSON */
  Json = "JSON",
  /** LONG */
  Long = "LONG",
  /** STRING */
  String = "STRING",
}

export const dashboardMetadataSchema = z.array(
  z.object({
    key: z.string(),
    value: z.string(),
    type: z.union([
      z.literal(MetadataType.Boolean),
      z.literal(MetadataType.Datetime),
      z.literal(MetadataType.Double),
      z.literal(MetadataType.Int),
      z.literal(MetadataType.Json),
      z.literal(MetadataType.Long),
      z.literal(MetadataType.String),
    ]),
  })
);

type DashboardMetadata = z.infer<typeof dashboardMetadataSchema>;

type MetadataObject = Record<
  string,
  boolean | Date | number | Record<string, unknown> | string | bigint
>;

export const metadataToObject = (metadata: DashboardMetadata): MetadataObject =>
  metadata.reduce<MetadataObject>((acc, { key, value, type }) => {
    switch (type) {
      case MetadataType.Boolean:
        acc[key] = value === "true";
        break;
      case MetadataType.Datetime:
        acc[key] = new Date(value);
        break;
      case MetadataType.Double:
        acc[key] = parseFloat(value);
        break;
      case MetadataType.Int:
        acc[key] = parseInt(value, 10);
        break;
      case MetadataType.Json:
        acc[key] = JSON.parse(value);
        break;
      case MetadataType.Long:
        acc[key] = BigInt(value);
        break;
      case MetadataType.String:
        acc[key] = value;
        break;
      default:
        break;
    }
    return acc;
  }, {});
